import { useState, useEffect } from 'react';
export function useFetch(fn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    let c = false;
    setLoading(true); setError(null);
    fn().then(d => { if (!c) setData(d); }).catch(e => { if (!c) setError(e.message); }).finally(() => { if (!c) setLoading(false); });
    return () => { c = true; };
    // eslint-disable-next-line
  }, deps);
  return { data, loading, error };
}
